module.exports = __webpack_public_path__ + "static/img/txt.4b6c8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/copyright/txt.png
// module id = Ospm
// module chunks = 1